import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRouteContext } from '../../context/RouteContext';
import ThankYouScreen from '../../components/shared/ThankYouScreen';

export default function ThankYouPage() {
  const { clearOrderDetails } = useRouteContext();
  const navigate = useNavigate();

  return (
    <ThankYouScreen
      onRedirect={() => {
        clearOrderDetails();
        navigate('/');
      }}
    />
  );
}
